import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const PayRateClientWageRenderer = (params) => {
  const {
    rowData: { summarized, subRows, clientPayroll },
    columnData: { key }
  } = params;

  const { currency } = useContext(ConfigContext);
  if (summarized || subRows) {
    return <></>;
  }

  const { wage } = clientPayroll || {};
  if ((wage || []).length === 0) {
    return <></>;
  }
  const wages = wage
    .filter(({ value }) => value > 0)
    .map((current) => `${currency}${current[key]} (${current.tag?.name})`)
    .join(', ');

  return <>{wages}</>;
};

export default PayRateClientWageRenderer;
